export default __webpack_public_path__ + "static/media/triangle-down.9ae0a08e.svg";